/*------------------------------------------------
// File Name:PDM_CONFIG_TEMPLATE.js
// File Description:PDM_CONFIG_TEMPLATE store方法
// Author:zxl
// Create Time:2022/08/22 11:27:54
//------------------------------------------------*/

import {
    GetPDM_CONFIG_TEMPLATEList,
    GetPDM_CONFIG_TEMPLATEListByPage,
    GetPDM_CONFIG_TEMPLATEEntity,
    CreatePDM_CONFIG_TEMPLATEEntity,
    UpdatePDM_CONFIG_TEMPLATEEntity,
    DeletePDM_CONFIG_TEMPLATEEntity,
} from '@/api/pdm/configTemplate'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmConfigTemplate = {
    namespaced: true,
    state: {
        PdmConfigTemplateList: [],
        PdmConfigTemplateListLoading: false,
        PdmConfigTemplateEntity: null,
        PdmConfigTemplateShowDlg: false,
    },
    mutations: {
        setPdmConfigTemplateList(state, dataList) {
            state.PdmConfigTemplateList = [...dataList]
        },
        setPdmConfigTemplateListLoading(state, visible) {
            state.PdmConfigTemplateListLoading = visible
        },
        setPdmConfigTemplateShowDlg(state, visible) {
            state.PdmConfigTemplateShowDlg = visible
        },
        setPdmConfigTemplateEntity(state, entity) {
            state.PdmConfigTemplateEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmConfigTemplate({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_CONFIG_TEMPLATEEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigTemplateEntity', res.Data)
                        commit('setPdmConfigTemplateShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmConfigTemplateEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigTemplateListLoading', true)
                GetPDM_CONFIG_TEMPLATEEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigTemplateList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigTemplateListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmConfigTemplateList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigTemplateListLoading', true)
                GetPDM_CONFIG_TEMPLATEList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigTemplateList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigTemplateListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmConfigTemplateListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigTemplateListLoading', true)
                GetPDM_CONFIG_TEMPLATEListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigTemplateList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigTemplateListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmConfigTemplate({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_CONFIG_TEMPLATEEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigTemplateShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_TEMPLATE
        actEditPdmConfigTemplateData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmConfigTemplateID : entity.PdmConfigTemplateID
                }
                GetPDM_CONFIG_TEMPLATEEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmConfigTemplateEntity', res.Data)
                        commit('setPdmConfigTemplateShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_TEMPLATE ,传对象过来
        actEditPdmConfigTemplate({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmConfigTemplateEntity', entity)
                commit('setPdmConfigTemplateShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_CONFIG_TEMPLATE
        actDeletePdmConfigTemplate({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_CONFIG_TEMPLATEEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmConfigTemplateShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


